import React, { useEffect, useState } from 'react';
import { crmRequest } from './crmApi';

export default function PrincipalSupplierSelect({value,onChange,currentSupplier,disabled=false}) {
    const [items,setItems]=useState([]),[loading,setLoading]=useState(true),[error,setError]=useState(''),[retry,setRetry]=useState(0);
    useEffect(()=>{
        let active=true;setLoading(true);setError('');
        (async()=>{
            const rows=[],seen=new Set();let total;
            for(let page=1;page<=10000;page++) {
                if(!active)return;
                const result=await crmRequest(`/opportunity-suppliers?page=${page}&pageSize=100`);
                if(!Array.isArray(result?.items)||!Number.isSafeInteger(result.total)||result.total<0||(total!==undefined&&total!==result.total)) throw new Error('El catálogo de proveedores cambió. Reintenta la consulta.');
                total=result.total;
                for(const row of result.items) {if(!row._id||seen.has(row._id)) throw new Error('No se pudo consultar el catálogo de proveedores.');seen.add(row._id);rows.push(row);}
                if(rows.length===total) {if(active)setItems(rows);return;}
                if(rows.length>total||!result.items.length) break;
            }
            throw new Error('No se pudo consultar el catálogo completo de proveedores.');
        })().catch(e=>{if(active)setError(e.message);}).finally(()=>{if(active)setLoading(false);});
        return ()=>{active=false;};
    },[retry]);
    const absent=value&&!items.some(row=>row._id===value);
    return <div>
        <select aria-label="Proveedor principal" value={value||''} disabled={disabled||loading||Boolean(error)} onChange={e=>onChange(e.target.value||null)}>
            <option value="">{loading?'Cargando proveedores…':'Sin proveedor principal'}</option>
            {absent&&<option value={value} disabled>{currentSupplier?.name||'Proveedor asignado anteriormente'}</option>}
            {items.map(row=><option key={row._id} value={row._id}>{row.name}</option>)}
        </select>
        {error&&<div role="alert">{error} <button type="button" onClick={()=>setRetry(n=>n+1)}>Reintentar proveedores</button></div>}
        <small>Catálogo de Clientes y contactos · Tipo Proveedor</small>
    </div>;
}
